import script from "./WordCloudWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WordCloudWidget.vue?vue&type=script&setup=true&lang=js"

import "./WordCloudWidget.vue?vue&type=style&index=0&id=6ce3b714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ce3b714"]])

export default __exports__